/**
 * 로그인 배타성 기록(점유 대기 표식·탭 신호·세션 출처)이 쓰는 localStorage 접근.
 *
 * 기록은 같은 오리진의 모든 탭이 함께 봐야 하므로 localStorage 에 둔다. 이 접근은 throw 하지 않는다:
 * SSR(`localStorage` 없음)이나 저장소가 막힌 브라우저에서 읽기는 null, 쓰기·삭제는 무동작이다.
 * 점유 대기 조회는 모든 fetch 에서 불리므로, 저장소 오류가 요청 전체를 깨뜨려서는 안 된다.
 */

export function readExclusiveLoginRecord(key: string): string | null {
  if (typeof localStorage === "undefined") return null;
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeExclusiveLoginRecord(key: string, value: string): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(key, value);
  } catch {
    // 저장소가 막힌 브라우저 — Amplify 토큰도 저장되지 않아 로그인 자체가 성립하지 않는다
  }
}

export function removeExclusiveLoginRecord(key: string): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.removeItem(key);
  } catch {
    // 저장소가 막힌 브라우저 — 지울 기록도 쓰이지 않았다
  }
}
